import React, { useContext } from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { Link } from 'react-router-dom';
import { ThemeContext } from '../context/ThemeContext';
import MaterialUISwitch from '../custom/CustomSwitch';
import logo from '../rsc/logo.png';
import { Avatar, Box, Paper } from '@mui/material';
import AvatarPicture from "../rsc/avatar.png"

const Navbar = () => {
    const { isDarkMode, toggleTheme } = useContext(ThemeContext);

    return (
        <AppBar color="primary" position="sticky">
            <Toolbar>
                {/* Logo Section */}
                <Box
                    display="flex"
                    alignItems="center"
                    sx={{ mr: 2 }}
                >
                    <Paper
                        elevation={0}
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            padding: '4px',
                            borderRadius: '50px',
                            backgroundColor: 'paper',
                        }}
                    >
                        <img src={logo} alt="logo" height="50" />
                    </Paper>
                </Box>

                {/* Title Section */}
                <Typography
                    variant="h5"
                    component="div"
                    sx={{ flexGrow: 1, fontWeight: 'bold' }}
                >
                    PowerSupport AI
                </Typography>

                {/* Navigation Buttons */}
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                    <Button color="inherit" component={Link} to="/j9vUzpr9Vqrfs75lDr8qAdHcgMPgKn6Q">
                        Home
                    </Button>
                    <Button color="inherit" component={Link} to="/j9vUzpr9Vqrfs75lDr8qAdHcgMPgKn6Q/dashboard">
                        Dashboard
                    </Button>
                    <Button color="inherit"  component={Link} to="/j9vUzpr9Vqrfs75lDr8qAdHcgMPgKn6Q/demo">
                        Demo
                    </Button>
                    {/* Theme Switch */}
                    <MaterialUISwitch checked={isDarkMode} onChange={toggleTheme} />

                    {/* User Avatar */}
                    <Avatar src={AvatarPicture} alt="logo" height="50" />
                </Box>
            </Toolbar>
        </AppBar>
    );
};

export default Navbar;
